import { DeliveryMode, PlayType } from '@kollective-frontend/ksdk-api';
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = (): void => {};

export enum SourceType {
  MP4 = 'MP4',
  HLS = 'HLS',
  DASH = 'DASH',
  SMOOTH = 'SMOOTH'
}

export enum MimeType {
  DASH = 'application/dash+xml',
  HLS = 'application/vnd.apple.mpegurl',
  HLS_GENERAL = 'application/x-mpegURL',
  MP4 = 'video/mp4',
  SMOOTH = 'application/vnd.ms-sstr+xml'
}

export enum Playback {
  BBP = 'b',
  CDN = 'c',
  ECDN10 = 't',
  ECDN11 = 'e'
}

export const PENDING_CLUSTER = 'PENDING_CLUSTER';

export const NOT_PEERABLE = 'NOT_PEERABLE';

// In interest of reducing impact of change export DeliveryMode and PlayType
// here, in a future commit this should be refactored properly
export { DeliveryMode, PlayType };

export enum WarningMessages {
  DIFFERENT_CONTENT_HOST = 'SdkConfig return content host that differs from host requested for config.'
}
